// AUTOGENERATED FILE - DO NOT EDIT

/**
 * All IAM policy actions for Amazon Message Gateway Service (SSMMESSAGES)
 *
 * Extracted by `aws-iam-policy` from
 * https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonmessagegatewayservice.html
 *
 * 2025-02-24T21:48:55.384Z
 */
export enum AwsSsmmessagesActions {
  /**
   * Grants permission to register a control channel for an instance to send control
   * messages to Systems Manager service
   *
   * See https://docs.aws.amazon.com/systems-manager/latest/userguide/getting-started-create-iam-instance-profile.html
   */
  CreateControlChannel = 'ssmmessages:CreateControlChannel',
  /**
   * Grants permission to register a data channel for an instance to send data messa
   * ges to Systems Manager service
   *
   * See https://docs.aws.amazon.com/systems-manager/latest/userguide/getting-started-create-iam-instance-profile.html
   */
  CreateDataChannel = 'ssmmessages:CreateDataChannel',
  /**
   * Grants permission to open a websocket connection for a registered control chann
   * el stream from an instance to Systems Manager service
   *
   * See https://docs.aws.amazon.com/systems-manager/latest/userguide/getting-started-create-iam-instance-profile.html
   */
  OpenControlChannel = 'ssmmessages:OpenControlChannel',
  /**
   * Grants permission to open a websocket connection for a registered data channel
   * stream from an instance to Systems Manager service
   *
   * See https://docs.aws.amazon.com/systems-manager/latest/userguide/getting-started-create-iam-instance-profile.html
   */
  OpenDataChannel = 'ssmmessages:OpenDataChannel',
}
